import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { faqData } from '../data/mock';
import { ChevronDown, HelpCircle, ArrowRight } from 'lucide-react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <span className="badge-minimal mb-6">FAQ</span>
          <h2 className="title-minimal mb-4">
            Frequently Asked <span className="title-accent">Questions</span>
          </h2>
          <p className="text-base text-[#4A4A5A]">
            Everything you need to know about our cleanroom solutions and services.
          </p>
        </motion.div>

        {/* FAQ Items */}
        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.03 }}
              className={`rounded-xl border transition-colors ${
                openIndex === index ? 'border-[#1C4B8A]/30 bg-[#FAFBFC]' : 'border-[#E5E7EB] bg-white'
              }`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                className="w-full px-5 py-4 flex items-center justify-between gap-4 text-left"
              >
                <div className="flex items-center gap-3">
                  <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors ${
                    openIndex === index ? 'bg-[#1C4B8A] text-white' : 'bg-[#1C4B8A]/10 text-[#1C4B8A]'
                  }`}>
                    <HelpCircle className="w-4 h-4" />
                  </div>
                  <span className={`text-sm font-medium transition-colors ${
                    openIndex === index ? 'text-[#1C4B8A]' : 'text-[#1A1A2E]'
                  }`}>
                    {faq.question}
                  </span>
                </div>
                <motion.div
                  animate={{ rotate: openIndex === index ? 180 : 0 }}
                  transition={{ duration: 0.2 }}
                >
                  <ChevronDown className="w-5 h-5 text-[#8A8A9A]" />
                </motion.div>
              </button>

              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.2 }}
                    className="overflow-hidden"
                  >
                    <div className="px-5 pb-5 pl-16 text-sm text-[#4A4A5A] leading-relaxed">
                      {faq.answer}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mt-12 p-8 rounded-xl bg-[#FAFBFC] border border-[#E5E7EB]"
        >
          <h3 className="text-lg font-semibold text-[#1A1A2E] mb-2">Still have questions?</h3>
          <p className="text-sm text-[#4A4A5A] mb-5">Our team is here to help you with any inquiries.</p>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium text-white bg-[#1C4B8A] rounded-lg hover:bg-[#153A6B] transition-colors"
          >
            Contact Us <ArrowRight className="w-4 h-4" />
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQSection;
